import styled from 'styled-components';

export default styled.h4`
    font-family: Lato;
     font-size: 12px;
     line-height: 16px;
     color: ${props => props.theme.forms.subheader};
     text-transform: uppercase;
     margin: 8px 0;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/form/BrandSubheaderFieldName.js